import { useMemo } from "react";

export function useIsMobile() {
  const isMobile = useMemo(
    () =>
      /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
        navigator.userAgent
      ),
    []
  );

  return isMobile;
}
